import { render, staticRenderFns } from "./DatavIntroduce.vue?vue&type=template&id=7250f2ea&"
import script from "./DatavIntroduce.vue?vue&type=script&lang=js&"
export * from "./DatavIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DatavIntroduce.vue"
export default component.exports